const InheritedConfigLabelStyle = theme => ({ readOnly: { backgroundColor: theme.palette.inheritedConfig.main } });

export default InheritedConfigLabelStyle;
